import { Versioning } from "@hex-insights/app-modules";
import { staticRequest } from "@hex-insights/roadium.shared";

const localVersion = process.env.REACT_APP_VERSION ?? "";

export function VersionController() {
	return <Versioning.VersionController version={localVersion} getCurrentVersion={getCurrentVersion} />;
}

async function getCurrentVersion() {
	const response = await staticRequest("/meta.json", { cache: "no-cache" });
	if (!response.ok) {
		return undefined;
	}
	let responseJSON: any;
	try {
		responseJSON = await response.json();
	} catch {
		return undefined;
	}
	return responseJSON.version;
}
